import { Controller } from "@hotwired/stimulus"

// Botão "olho" que alterna entre type=password e type=text num input.
// Uso:
//   <div data-controller="password-reveal">
//     <input type="password" data-password-reveal-target="input">
//     <button type="button" data-action="password-reveal#toggle"
//             data-password-reveal-target="button">👁</button>
//   </div>
// Ou com helper Ruby `password_field_with_reveal` (ver application_helper.rb).
export default class extends Controller {
  static targets = ["input", "button"]

  toggle(event) {
    event.preventDefault()
    const isHidden = this.inputTarget.type === "password"
    this.inputTarget.type = isHidden ? "text" : "password"
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-label", isHidden ? "Esconder" : "Mostrar")
      this.buttonTarget.innerHTML = isHidden ? this.constructor.eyeOffSvg : this.constructor.eyeSvg
    }
  }

  static eyeSvg = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>`
  static eyeOffSvg = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/></svg>`
}
